import { render, staticRenderFns } from "./TOSRecord.vue?vue&type=template&id=6b72e820&scoped=true&name=component-name&"
import script from "./TOSRecord.vue?vue&type=script&lang=js&"
export * from "./TOSRecord.vue?vue&type=script&lang=js&"
import style0 from "./TOSRecord.vue?vue&type=style&index=0&id=6b72e820&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b72e820",
  null
  
)

export default component.exports